<template>
  <div class="flex items-center gap-2">
    <div class="flex overflow-hidden rounded-md border border-default p-1 border-solid">
      <button
        type="button"
        :class="[
          'border-none flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm',
          activeSpace === 'shared'
            ? 'bg-brand-50 font-medium text-brand-default'
            : 'bg-transparent text-subtle hover:bg-brand-50',
        ]"
        @click="$emit('space-change', 'shared')"
      >
        <Icon
          type="users"
          class="h-3.5 w-3.5"
        />
        Shared
      </button>
      <button
        type="button"
        :class="[
          'border-none ml-1 flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm',
          activeSpace === 'private'
            ? 'bg-brand-50 font-medium text-brand-default'
            : 'bg-transparent text-subtle hover:bg-brand-50',
        ]"
        @click="$emit('space-change', 'private')"
      >
        <Icon
          type="lock"
          class="h-3.5 w-3.5"
        />
        Private
      </button>
    </div>

    <button
      type="button"
      class="bg-transparent border-none flex items-center gap-1 text-sm text-subtle hover:text-emphasis"
      @click="$emit('how-it-works-click')"
    >
      How this works
      <Icon
        type="info-circle"
        class="h-3.5 w-3.5"
      />
    </button>
  </div>
</template>

<script>
import Icon from '@/components/ui/Icon.vue';

export default {
  name: 'FlowsSpaceToggle',
  components: { Icon },
  props: {
    activeSpace: {
      type: String,
      default: 'shared',
      validator: (value) => ['shared', 'private'].includes(value),
    },
  },
  emits: ['space-change', 'how-it-works-click'],
};
</script>
